import React from 'react';
import { Formik, useField, Form } from 'formik';
import './Forms.css';
import * as Yup from 'yup';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';


const CustomTextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props)
    return (
        <>
            <label className="labelForms" htmlFor={props.id || props.name}>{label}</label>
            <input className="text-input-forms"{...field}{...props} />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </>
    )
}
const CustomSelect = ({ label, ...props }) => {
    const [field, meta] = useField(props)
    return (
        <>
            <label htmlFor={props.id || props.name}>{label}</label>
            <select {...field}{...props} />
            {meta.touched && meta.error ? (
                <div className="error-select">{meta.error}</div>
            ) : null}
        </>
    )
}


export default function FormsAddLicense() {
    return (
        <Formik
            initialValues={{
                name: '',
                license: '',
                quantity: '',
                date: '',
                demo: '',
            }}
            validationSchema={Yup.object({
                name: Yup.string()
                    .required('Nome não pode ficar em branco!'),
                license: Yup.string()
                    .oneOf(['1', '2'])
                    .required('Necessário escolher a licença que deseja renovar!'),
                quantity: Yup.string()
                    .oneOf(['1', '2', '3', '4'])
                    .required('Necessário escolher a quantidade!'),
                date: Yup.string()
                    .oneOf(['1mes', '3meses', '6meses', '1ano', '2anos'])
                    .required('Necessário escolher uma data!'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                setTimeout(() => {
                    console.log(values)
                    alert(JSON.stringify(values, null, 2));
                    resetForm();
                    setSubmitting(false);
                }, 3000)
            }}
        >
            <div className="formsContainer">
                <Form>
                    <div className="tittleForms">
                        <h3>Gerar Licença</h3>
                    </div>
                    <h6>Empresa:</h6>
                    <CustomTextInput name="name" type="text" placeholder="Digite o nome da empresa" />
                    {/* <h6>E-mail:</h6>
                        <CustomTextInput name="email" type="email" placeholder="Digite seu email" /> */}
                    <h6>Duração:</h6>
                    <CustomSelect name="date">
                        <option value="">Selecione o tempo</option>
                        <option value="1mes">1 mês</option>
                        <option value="3meses">3 meses</option>
                        <option value="6meses">6 meses</option>
                        <option value="1ano">1 ano</option>
                        <option value="1ano">2 anos</option>
                    </CustomSelect>
                    <h6>Licença: </h6>
                    <CustomSelect name="license">
                        <option value="">Selecione o tipo</option>
                        <option value="1">Historian</option>
                        <option value="2">PiD</option>
                    </CustomSelect>
                    <h6>Tags: </h6>
                    <CustomSelect name="quantity">
                        <option value="">Selecione a quantidade</option>
                        <option value="1">10</option>
                        <option value="2">100</option>
                        <option value="3">500</option>
                        <option value="4">1000</option>
                    </CustomSelect>
                    <FormControlLabel
                        value="start"
                        control={<Checkbox />}
                        label="Demonstração:"
                        labelPlacement="start"
                    />
                    <div className="buttonFormsContainerAdd">
                        <Button type="submit" variant="contained">Adicionar licença</Button>
                    </div>
                </Form>
            </div>
        </Formik>
    );
}